<template>
  <div>
    <div v-if="isNew">Please select the survey location</div>
    <b-row align-h="end" class="text-left">
      <b-col>
        <b-form-select
          v-if="isNew"
          v-model="$v.selected.$model"
          :class="{ 'is-invalid': isInvalid }"
        >
          <option
            v-for="loc in locations"
            :key="loc.id"
            :value="{ locId: loc.id, locName: loc.name }"
          >{{ loc.name }}</option>
        </b-form-select>

        <div v-else>
          <b-form-input v-model="search" type="text" placeholder="Type a location name"></b-form-input>
          <b-table
            striped
            hover
            :items="filteredItems"
            :fields="fields"
            empty-text="No matching results"
          >
            <template slot="Download" slot-scope="row">
              <!-- <font-awesome-icon icon="download" @click="downloadData(row.item)" class="fa-1x"/>  -->
              <font-awesome-icon icon="download" @click="downloadData(row.item)" class="fa-1x"/>  
            </template>
            <template slot="Add" slot-scope="row">
              <font-awesome-icon icon="plus" @click="setLocation2(row.item)" class="fa-1x"/>  
              <!-- <b-button @click.stop="setLocation2(row.item)">Add</b-button> -->
            </template>
          </b-table>
        </div>
        <b-alert v-if="hasError" show variant="danger">Error or no access!!!</b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ajax from "@/resources/myApi.js";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)

export default {
  name: "survey-location-grid",
  props: ["location", "isValid", "isNew"],
  data: () => ({
    search: "",
    selected: null,
    locationId: 0,
    locations: [],
    isInvalid: false,
    hasError: false,
    items: [],
    fields: [
      {
        key: "locationName",
        sortable: true
      },
      {
        key: "locationDate",
        sortable: true
      },
      {
        key: "surveyCount",
        label: "# of Surveys",
        sortable: true
      },
      {
        key: "Download",
        label: ""

      },
      {
        key: "Add",
        label: ""
      }
    ]
  }),
  validations: {
    selected: {
      required
    }
  },
  methods: {
    setLocation() {
      if (this.$v.selected.required) this.$emit("set-location", this.selected);
      else this.isInvalid = true;
    },
    setLocation2(item) {
      this.$emit("set-location", {
        locId: item.locationId,
        locName: item.locationName
      });
    },
    async downloadData(item){
      console.log(item, "Item")

      const {data} = await ajax.get("surveys/toExcel/" + item.locationId, {
            name: 'document',
            responseType: 'blob'
          });

          const fileUrl = URL.createObjectURL(data);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = fileUrl;
          a.download = item.locationName + " Surveys.xlsx";
          a.click();
          window.URL.revokeObjectURL(fileUrl);
          document.body.removeChild(a);
          this.isPrintLoading = false;
    },
    onLoad() {
      console.log("another onload");
      if (this.isNew)
        ajax
          .get("locations/active")
          .then(res => {
            this.locations = res.data;
            this.hasError = false;
          })
          .catch(error => {
            console.log(error);
            this.hasError = true;
          });
      else {
        ajax
          .get("locations/fullhistory")
          .then(res => { 
            this.items = res.data; 
            this.hasError = false;
          })
          .catch(error => {
            console.log(error);
            this.hasError = true;
          });
      }
    },
    handleResponse(arr) {
      let processedItems = [];
      arr = null;
    }
  },
  computed: {
    filteredItems() {
      return this.items.filter(i => {
        return i.locationName.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  mounted() {
    this.onLoad();
  },
  created() {
    //this.onLoad();
  },

  watch: {
    selected() {
      if (this.selected.locId) this.isInvalid = false;
    }
  }
};
</script>

<style scoped>
.row {
  padding-bottom: 20px;
}
.card {
  min-width: 25%;
  margin: 10px;
}
</style>